import Color from 'color'

const colors = {
  primary: '#EB263A',
  primaryHover: Color('#EB263A').lighten(0.2).hex(),
  secondary: '#FF6465',
  secondHover: Color('#FF6465').lighten(0.2).hex(),
  tertiary: '#B10014',
}

export default colors
